module.exports = function (paths) {
    const FURTHER_REF = paths.FURTHER_REF

    return {
        test: /\.vue$/,
        // use: [
        //   // { loader: FURTHER_REF + 'vue-style-loader' },
        //   // { loader: FURTHER_REF + 'style-loader' },
        //   // { loader: FURTHER_REF + 'css-loader' },
        //   // { loader: FURTHER_REF + 'less-loader' },
        //   // { loader: FURTHER_REF + 'styl-loader' },
        //   // { loader: FURTHER_REF + 'sass-loader' },
        //   // { loader: FURTHER_REF + 'babel-loader' },
        //   { loader: FURTHER_REF + 'vue-html-loader' },
        // ],

        loader: FURTHER_REF + 'vue-loader',
        options: {
            // presets: [
            //   [ FURTHER_REF + 'babel-preset-es2015', { loose: true, modules: false } ],
            //   FURTHER_REF + 'vue-loader'
            // ],
            loaders: {
            js: FURTHER_REF + 'babel-loader',
            css: FURTHER_REF + 'vue-style-loader!'+ FURTHER_REF +'css-loader'
            // css: FURTHER_REF + 'vue-style-loader'
            },
            // extractCSS: true,
            // postcss: [postCSSNext()]
        }
    }
}



// WEBPACK FOOTER //
// ./src/technologies/vue.js